




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import AddQuestActionModal from './AddQuestActionModal.vue';

@Component({
    components: {
        AddQuestActionModal
    }
})
export default class QuestListsTable extends Vue {
    headers = [
        {
            text: 'Atomic Action',
            align: 'start',
            sortable: false,
            value: 'atomic_action',
        },
        {
            text: 'API',
            align: 'start',
            sortable: false,
            value: 'api_hook',
        },
        {
            text: 'Base X Action',
            align: 'start',
            sortable: false,
            value: 'base_value_x_action',
        },
        {
            text: 'Quest Bonus',
            align: 'start',
            sortable: false,
            value: 'quest_bonus',
        },
        {
            text: 'Quest Multiplyer',
            align: 'start',
            sortable: false,
            value: 'quest_multiplyer',
        },
        {
            text: 'Est. Diff. Level (Norm)',
            align: 'start',
            sortable: false,
            value: 'est_diff_lev',
        },
        {
            text: 'Est. Time (sec)',
            align: 'start',
            sortable: false,
            value: 'est_time',
        },
        {
            text: '',
            align: 'start',
            sortable: false,
            value: 'actions',
        },
        {
            text: '',
            align: 'end',
            value: 'data-table-expand'
        }
    ];

    query = {};
    pagination = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
    };

    public get fetchQuery() {
        return Object.assign({}, {
            ...this.query,
            // ...this.extendedQuery,
            $populate: true
        }, {
            // ...this.searchQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        });
    }

    public get dataQuery() {
        return {
            ...this.query,
            // ...this.extendedQuery,
            // ...this.searchDataQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        };
    }

    public get sortingQuery() {
        if(this.pagination.sortBy.length !== 0) {
            const $sort: any = {};
            this.pagination.sortBy.map((item, index) => {
                switch(item) {
                    default:
                        $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                }
                
            });
            return { $sort };
        }
        return null;
    }
}
